/*
 * Actions types
 */
export enum AppControllersTypes {
  AUTHENTICATION_STEP = '@appControlers/AUTHENTICATION_STEP',
  SELECT_EMAIL = '@appControlers/SELECT_EMAIL',
}

/*
 * State Type
 */
export interface AppControllersState {
  readonly emailSelected: number | undefined;
  readonly authenticationStep: number;
}
